import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import EventCard from './components/elements/eventCard';
import { events } from './events';
import Register from './components/elements/Register';
import AudioPlayer from './components/audio';
function App() {
  return (
    <Router>
      <div>
        <AudioPlayer/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Capture-the-Throne" element={<EventCard eventData={events[0]} />} />
          <Route path="/Scrolls-of-the-Seven-Kingdoms" element={<EventCard eventData={events[1]} />} />
          <Route path="/Quest-Beyond-the-Wall" element={<EventCard eventData={events[2]} />} />
          <Route path="/The-Iron-Code-Relay" element={<EventCard eventData={events[3]} />} />
          <Route path="/Defenders-Pitch" element={<EventCard eventData={events[4]} />} />
          <Route path="/Drogons-Hackfest" element={<EventCard eventData={events[5]} />} />
          <Route path="/The-Kings-Design" element={<EventCard eventData={events[6]} />} />
          <Route path="/The-War-for-Westeros" element={<EventCard eventData={events[7]} />} />
          <Route path="/workshop" element={<EventCard eventData={events[8]}/>}/>
          <Route path="/:eventName/register" element={<Register />} />
        </Routes>
      </div>
  </Router>
  );
}

export default App;
